import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import EditProfile from './pages/EditProfile';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SharedChatView from './pages/SharedChatView';
import ExamsPage from './pages/ExamsPage';
import ExamDetailPage from './pages/ExamDetailPage';
import QuestionBankHome from './pages/QuestionBankHome';
import QuestionBankPractice from './pages/QuestionBankPractice';
import QuestionBankBookmarks from './pages/QuestionBankBookmarks';
import QuestionBankRevision from './pages/QuestionBankRevision';
import ContactUs from './pages/ContactUs';
import FeedbackPage from './pages/FeedbackPage';
import { initGA, logPageView } from './utils/analytics';
// Presentation imports removed

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
  const isLoginPage = location.pathname === '/login';
  const isDashboardPage = location.pathname === '/dashboard' || location.pathname === '/chat' || location.pathname.startsWith('/chat/') || location.pathname === '/exams' || location.pathname.startsWith('/exams/') || location.pathname === '/question-bank' || location.pathname.startsWith('/question-bank/');
  const isLoadingPage = location.pathname.includes('/loading');
  const isEditProfilePage = location.pathname === '/edit-profile';
  const isLegalPage = location.pathname === '/terms' || location.pathname === '/privacy';
  const isSharedChatPage = location.pathname.startsWith('/share/');
  const isFeedbackPage = location.pathname === '/feedback';

  const navigateToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="App">
      {!isLoginPage && !isDashboardPage && !isEditProfilePage && !isLegalPage && !isSharedChatPage && !isLoadingPage && !isFeedbackPage && <Navbar onTryNowClick={navigateToLogin} />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/chat" element={<Dashboard />} />
        <Route path="/chat/:chatId" element={<Dashboard />} />
        <Route path="/exams" element={<ExamsPage />} />
        <Route path="/exams/:examId" element={<ExamDetailPage />} />
        <Route path="/question-bank" element={<QuestionBankHome />} />
        <Route path="/question-bank/practice" element={<QuestionBankPractice />} />
        <Route path="/question-bank/book/:bookId" element={<QuestionBankPractice />} />
        <Route path="/question-bank/bookmarks" element={<QuestionBankBookmarks />} />
        <Route path="/question-bank/revision" element={<QuestionBankRevision />} />
        <Route path="/share/:shareToken" element={<SharedChatView />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/feedback" element={<FeedbackPage />} />
      </Routes>
      {!isLoginPage && !isDashboardPage && !isEditProfilePage && !isLegalPage && !isSharedChatPage && !isLoadingPage && !isFeedbackPage && <Footer />}
    </div>
  );
}

function App() {
  // Initialize Google Analytics once when app starts
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
